import { useEffect, useRef } from 'react';

// Per-screen a11y wiring for the app-style navigation. A client-side route change
// remounts the destination screen but React Router never moves focus (it stays on
// the now-unmounted trigger and falls to <body>) and never updates the page title
// (index.html's <title> is a static "Halo"). This hook does both for one screen:
//   • sets document.title to "<title> · Halo" (or bare "Halo" when title is empty)
//   • returns a ref for the screen's <h1>, focused once on mount so a keyboard / SR
//     user lands on the screen's name on arrival instead of at the top of <body>.
// Put the returned ref on an `<h1 tabIndex={-1}>` — a heading is not focusable
// otherwise. The auth screens use the same focus pattern inline.
export default function useScreen(title) {
  const headingRef = useRef(null);

  useEffect(() => {
    document.title = title ? `${title} · Halo` : 'Halo';
  }, [title]);

  useEffect(() => {
    // Mount ≈ navigation here: a re-render (e.g. a WebSocket frame) does not remount
    // the screen, so focus is not yanked mid-interaction — it only moves on arrival.
    headingRef.current?.focus();
  }, []);

  return headingRef;
}
